import React from 'react'
import {useIntl} from 'react-intl'
import {Text, HStack, useMultiStyleConfig, TextProps} from '@chakra-ui/react'

interface PriceProps {
    discountedPrice?: string | React.ReactNode
    discountedPriceMinRange?: string | React.ReactNode
    priceMinRange?: string | React.ReactNode
    id?: string
    children: string | React.ReactNode
}

const Price = ({discountedPrice, discountedPriceMinRange, priceMinRange, id, children}: PriceProps) => {
    const styles = useMultiStyleConfig('Price') as Record<string, TextProps>
    const {formatMessage} = useIntl()
    const discountedPriceMinRangeLabel = formatMessage(
        {
            id: 'label.range.price.child',
            defaultMessage: 'A partire da {0}',
        },
        {0: discountedPriceMinRange},
    )
    const priceMinRangeLabel = formatMessage(
        {
            id: 'label.range.price.child',
            defaultMessage: 'A partire da {0}',
        },
        {0: priceMinRange},
    )

    return (
        <HStack {...styles.wrapper}>
            {discountedPrice && <Text {...styles.price}>{discountedPrice}</Text>}
            {discountedPriceMinRange && <Text {...styles.price}>{discountedPriceMinRangeLabel}</Text>}
            <Text id={id} {...styles.price} {...(discountedPrice || discountedPriceMinRange ? styles.discountedPrice : {})}>
                {priceMinRange ? priceMinRangeLabel : children}
            </Text>
        </HStack>
    )
}

export {Price}
